import fetch from 'isomorphic-fetch'
import {pendingTask, begin, end} from 'react-redux-spinner'
import {GET_VENUE_REQUEST, GET_VENUE, GET_VENUE_ERROR} from './types'

export function getVenueRequest() {
  console.log('get venue request')
  const data = {
    loading: true,
  }
  return {
    type: GET_VENUE_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function getVenueSuccess(venue) {
  console.log('venue: ' + JSON.stringify(venue))
  const data = {
    loading: false,
    venue,
  }
  return {
    type: GET_VENUE,
    [pendingTask]: end,
    payload: data,
  }
}

export function getVenueFail(error) {
  const data = {
    loading: false,
    error,
  }
  return {
    type: GET_VENUE_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function getVenue(id) {
  //console.log('GET A VENUE WITH ID: ' +id);
  return dispatch => {
    dispatch(getVenueRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/venue/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    })
      .then(res => res.json())
      .then(json => {
        //console.error('getVenue: ' + JSON.stringify(json.venue))
        dispatch(getVenueSuccess(json.venue))
      })
      .catch(error => dispatch(getVenueFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/venue_show.js
 **/